import React, { useState } from 'react';
import styles from './W_CapsulePostAuthorDate.module.css';
import W_CapsuleCreators from '../W_CapsuleCreators/W_CapsuleCreators';
import cn from 'classnames';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { formatDate } from '@/utils/formatters';
import M_CapsulePostActionsDropdown from '@/components/M_Molecules/M_ContextMenu/M_ContextMenu';

interface W_CapsulePostAuthorDateProps {
  avatars: string[];
  coauthors: number;
  date: string;
  isMyCapsule?: boolean;
  ownerName?: string;
  ownerId?: string;
  showActionsMenu?: boolean;
  onDelete?: () => void;
  capsuleId?: string;
}

export default function W_CapsulePostAuthorDate({
  date,
  avatars,
  coauthors,
  isMyCapsule,
  ownerName,
  ownerId,
  showActionsMenu = false,
  onDelete,
  capsuleId,
}: W_CapsulePostAuthorDateProps) {
  const [isActionsOpen, setIsActionsOpen] = useState(false);
  const actionsAnchorRef = React.useRef<HTMLDivElement>(null);

  const hasMenu = Boolean(capsuleId);
  const shareUrl =
    typeof window !== 'undefined' && capsuleId
      ? `${window.location.origin}/capsule/${capsuleId}`
      : '';

  return (
    <div className={styles.wrapper}>
      <W_CapsuleCreators
        avatars={avatars}
        coauthors={coauthors}
        isMyCapsule={isMyCapsule}
        ownerName={ownerName}
        ownerId={ownerId}
      />
      <div className={styles.action_wrapper}>
        <span className={cn(styles.date_text, 'text-p-7')}>
          {formatDate(date)}
        </span>
        {hasMenu ? (
          <div ref={actionsAnchorRef} className={styles.actions_anchor}>
            <button
              type='button'
              className={styles.button}
              onClick={() => setIsActionsOpen(prev => !prev)}
              aria-haspopup='menu'
              aria-expanded={isActionsOpen}
            >
              <Q_Icon.ThreePointsIcon
                width={26}
                height={6}
                fill='currentColor'
              />
            </button>
            <M_CapsulePostActionsDropdown
              isOpen={isActionsOpen}
              onClose={() => setIsActionsOpen(false)}
              shareUrl={shareUrl}
              showDelete={Boolean(showActionsMenu && onDelete)}
              onDelete={onDelete}
              anchorRef={actionsAnchorRef}
            />
          </div>
        ) : (
          <button type='button' className={styles.button}>
            <Q_Icon.ThreePointsIcon width={26} height={6} fill='currentColor' />
          </button>
        )}
      </div>
    </div>
  );
}
